// extracted by mini-css-extract-plugin
export default {"description":"description--nwQWq","label":"label--ByPa5"};